import "./ProgressSpinnerOverlay.scss";
import "primeflex/primeflex.scss";

import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";

type Props = {
  displayOverlay: boolean;
  waitMessage: string;
};

export const ProgressSpinnerOverlay: React.FC<Props> = (props: Props) => {
  return (
    <>
      <div
        id="overlay"
        style={{ display: `${props.displayOverlay ? "block" : "none"}` }}
      >
        <div className="spinner-centered p-text-center">
          <div className="p-md-12 large-text">{props.waitMessage}</div>
          <div className="p-md-12">
            <ProgressSpinner className="big-spinner" strokeWidth="4" />
          </div>
        </div>
      </div>
    </>
  );
};
